import { getURLParameter } from './utils';
import { store } from './react-initialize';
import * as HeaderActions from './Header/actions';

(function() {
   function onCartAddComplete(response) {
      if (shouldRedirectAfterAdd()) {
         window.location = window.shared_constants.BaseURI('TAG_CHECKOUT_CART');
         return;
      }

      if (!response) {
         return;
      }

      var miniCart = response.miniCart;

      when(window.ProductViewPage, function() {
         ProductViewPage.updateAvailability(response.optionid, response.avail);
      });

      store.dispatch(HeaderActions.updateMiniCart(miniCart));

      TweenLite.to(window, 0.5, {
         scrollTo: 0,
         onComplete: function() {
            const click = new Event('click', { bubbles: true });
            document.getElementById('miniCartDropdownToggle').dispatchEvent(click);
         },
      });
   }

   // We should redirect if the mini cart is "simple" (e.g user has ton of products
   // or is on a mobile device)
   function shouldRedirectAfterAdd() {
      return document.getElementById('hydra-minicart-simple');
   }

   // We need to listen for this event whether or not we have a mini cart
   // because we may need to redirect to the cart page.
   listenGlobal('cart.addcomplete', onCartAddComplete);
})();
